import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '@/lib/analytics';

/**
 * Fires $pageview on every React-Router location change. Mount once at the
 * top of the tree (inside <Router>). Also re-captures UTMs from URL so
 * mid-session inbound UTM'd links (e.g., user clicks a different email link)
 * update the last-touch snapshot.
 */
export function usePageviewTracker(): void {
  const location = useLocation();

  useEffect(() => {
    // Update UTM snapshots if this URL carries them.
    analytics.captureUtmsFromUrl();
    // Build absolute URL for $current_url so it matches PostHog conventions.
    const url =
      typeof window !== 'undefined'
        ? window.location.origin + location.pathname + location.search
        : location.pathname;
    analytics.track('$pageview', { $current_url: url });
  }, [location.pathname, location.search]);
}
